import { ReactElement } from "react";

import { BillPaymentType, MovementType, PaymentType } from "@meditect/medibase-api-client";
import { Tag, TagLabel, TagLeftIcon, TagProps, Tooltip, useBreakpointValue } from "@meditect/medibase-components";

import { paymentMethods } from "@/features/checkout/const/paymentMethods";

export interface PaymentTagProperties extends TagProps {
  collapseBreakpoint?: string;
  iconOnly?: boolean;
  type: BillPaymentType | MovementType | PaymentType;
}

export const PaymentTag = ({
  collapseBreakpoint = "base",
  iconOnly = false,
  type,
  ...rest
}: PaymentTagProperties): ReactElement => {
  const properties = Object.values(paymentMethods).find((p) => p.type === type);
  if (properties == null) {
    throw new Error("Invalid payment type");
  }

  const isCollapsed = useBreakpointValue(
    {
      base: true,
      [collapseBreakpoint]: false,
    },
    { ssr: false },
  );

  return (
    <Tooltip isDisabled={!iconOnly && !isCollapsed} label={properties.title} placement="top">
      <Tag
        background={properties.tagBackground}
        color={properties.tagColor}
        h="fit-content"
        pr={iconOnly ? 0 : undefined}
        {...rest}
      >
        <TagLeftIcon as={properties.icon} boxSize="3" mr={isCollapsed ? 0 : undefined} />
        {!iconOnly && !isCollapsed && <TagLabel>{properties.title}</TagLabel>}
      </Tag>
    </Tooltip>
  );
};
